<template>
	<ScaleScreen :width="1920" :height="1080" class="scale-wrap">
		<dv-loading
			v-if="loading"
			style="position: absolute; z-index: 10; background: #0d1827"
		>
			Loading...
		</dv-loading>
		<div class="layout-container">
			<!-- 可加个导航栏 -->
			<header class="header">
				<img
					class="layout-img"
					src="../assets/image/header/layout.png"
					alt="导航栏"
				/>
				<div class="time-container">
					<div class="flex align-center justify-evenly">
						<div class="date">
							{{ dateYear }}
						</div>
						<div class="date">
							{{ dateWeek }}
						</div>
						<div class="date-day">
							{{ dateDay }}
						</div>
					</div>
				</div>
				<div class="meun-vehicle" @click="onChange(0)">
					<img class="menu-bg" src="../assets/image/header/left-bg.png" />
					<div class="meun-title">{{ menuList[0] }}</div>
				</div>
				<div class="meun-battery" @click="onChange(1)">
					<img class="menu-bg" src="../assets/image/header/left-bg.png" />
					<div class="meun-title">{{ menuList[1] }}</div>
				</div>
				<div class="meun-cabinet" @click="onChange(2)">
					<img class="menu-bg" src="../assets/image/header/left-bg.png" />
					<div class="meun-title">{{ menuList[2] }}</div>
				</div>
				<div class="layout-title">{{ menuList[3] }}</div>
				<div class="meun-fault" @click="onChange(4)">
					<img class="menu-bg" src="../assets/image/header/right-bg.png" />
					<div class="meun-title">{{ menuList[4] }}</div>
				</div>
				<div class="meun-data" @click="onChange(5)">
					<img class="menu-bg" src="../assets/image/header/right-bg.png" />
					<div class="meun-title">{{ menuList[5] }}</div>
				</div>
				<div class="meun-no">
					<img class="menu-bg" src="../assets/image/header/right-bg.png" />
					<div class="meun-title">{{ menuList[6] }}</div>
				</div>
				<screenfull class="effect" />
				<div class="logout" @click="logout">退出</div>
			</header>

			<!-- 页面内容区 -->
			<main class="content-layer">
				<!-- 全局地图（放在最底层,数据中心不显示） -->
				<!-- 添加之后，如果从云平台直接进入换电柜详情页，点击返回地图不渲染，
        因为改为任何时候都渲染，通过z-index控制 -->
				<!-- <div v-show="shouldShowMap" class="map-layer"> -->
				<div class="map-layer">
					<operation-map
						:data="$store.state.mapData"
						:center="$store.state.center"
						:top="$store.state.mapTop"
					></operation-map>
				</div>
				<router-view />
			</main>
		</div>
	</ScaleScreen>
</template>

<script>
	import ScaleScreen from "@/components/scale-screen.vue";
	import OperationMap from "@/components/maps/operationMap.vue";
	import Screenfull from "@/components/screenfull";
	import { formatTime } from "@/utils/index.js";
	import { logout } from "@/api/login";

	export default {
		name: "Layout",
		components: { OperationMap, ScaleScreen, Screenfull },
		data() {
			return {
				originMenuList: [
					"车辆监控",
					"电池监控",
					"换电柜监控",
					"运营大厅",
					"故障告警",
					"数据中心",
					"---"
				],
				menuList: [
					"车辆监控",
					"电池监控",
					"换电柜监控",
					"运营大厅",
					"故障告警",
					"数据中心",
					"---"
				],
				timing: null, // 时间定时器
				dateDay: "00:00",
				dateYear: "2025-01-01",
				dateWeek: "星期一",
				weekday: [
					"星期日",
					"星期一",
					"星期二",
					"星期三",
					"星期四",
					"星期五",
					"星期六"
				]
			};
		},
		computed: {
			loading() {
				return this.$store.state.loading;
			},
			shouldShowMap() {
				// 计算属性：根据当前路由决定是否展示地图
				return !["Data", "CabinetDetail"].includes(this.$route.name);
			}
		},
		watch: {
			$route(to) {
				const index = this.menuList.indexOf(to.meta.title);

				if (index !== 3) {
					// 更换位置
					this.$set(this.menuList, index, this.menuList[3]);
					this.$set(this.menuList, 3, to.meta.title);
					// 更新菜单状态
					localStorage.setItem("menuList", JSON.stringify(this.menuList));
				}
			}
		},
		created() {
			// 获取当前时间
			this.timeFn();

			// 新增：处理通过KEY链接进入的情况
			const isFromKeyEntry = localStorage.getItem("isFromKeyEntry");

			if (isFromKeyEntry === "true") {
				this.menuList = [...this.originMenuList];
				// 交换换电柜监控和运营大厅的位置（让换电柜监控显示在header中间）
				[this.menuList[2], this.menuList[3]] = [
					this.menuList[3],
					this.menuList[2]
				];
				// 保存调整后的菜单到本地存储
				localStorage.setItem("menuList", JSON.stringify(this.menuList));
				// 清除标记，避免下次进入重复生效
				localStorage.removeItem("isFromKeyEntry");
				// 跳转到换电柜监控页面
				this.toPage("换电柜实时监控");
			} else {
				const cacheMenu = localStorage.getItem("menuList");
				// 是否有缓存菜单
				if (cacheMenu) {
					this.menuList = JSON.parse(cacheMenu);
					if (this.$route.query.cabinetSn) {
						this.toPage("换电柜实时监控");
					} else {
						this.toPage(this.menuList[3]);
					}
				} else {
					// 无缓存时使用原始菜单
					this.menuList = [...this.originMenuList];
					this.toPage(this.menuList[3]);
				}
			}
		},
		beforeDestroy() {
			// 清除定时器
			clearInterval(this.timing);
		},
		methods: {
			// 切换菜单
			onChange(index) {
				const temp = this.menuList[index];
				// 更换位置
				this.$set(this.menuList, index, this.menuList[3]);
				this.$set(this.menuList, 3, temp);
				// 存储
				localStorage.setItem("menuList", JSON.stringify(this.menuList));
				// 判断跳转页面
				this.toPage(temp);
			},
			// 遍历要去的页面
			toPage(name) {
				// 判断跳转页面
				switch (name) {
					case "车辆监控":
						if (this.$route.name !== "Vehicle") {
							this.$router.push({ name: "Vehicle" });
						}
						break;
					case "电池监控":
						if (this.$route.name !== "Battery") {
							this.$router.push({ name: "Battery" });
						}
						break;
					case "换电柜监控":
						if (this.$route.name !== "Cabinet") {
							this.$router.push({ name: "Cabinet" });
						}
						break;
					case "换电柜实时监控":
						if (this.$route.name !== "CabinetDetail") {
							this.$router.push({ name: "CabinetDetail" });
						}
						break;
					case "运营大厅":
						if (this.$route.name !== "Home") {
							this.$router.push({ name: "Home" });
						}
						break;
					case "故障告警":
						if (this.$route.name !== "Fault") {
							this.$router.push({ name: "Fault" });
						}
						break;
					case "数据中心":
						if (this.$route.name !== "Data") {
							this.$router.push({ name: "Data" });
						}
						break;
					default:
						break;
				}
			},
			// 获取当前时间
			timeFn() {
				this.timing = setInterval(() => {
					this.dateDay = formatTime(new Date(), "HH:mm");
					this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
					this.dateWeek = this.weekday[new Date().getDay()];
				}, 1000);
			},
			logout() {
				this.$confirm("确定注销并退出系统吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				})
					.then(() => {
						logout().then(() => {
							localStorage.clear();
							location.href = "/";
						});
					})
					.catch(() => {});
			}
		}
	};
</script>

<style lang="scss" scoped>
	// 容器
	.scale-wrap {
		color: #ffffff;
		width: 1920px;
		height: 1080px;
		overflow: hidden;

		.layout-container {
			position: relative;
		}

		/* 内容区域要高于地图 */
		.content-layer {
			position: relative;
			width: 1920px;
			height: 1080px;
			z-index: 1;

			/* 地图全屏铺底 */
			.map-layer {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				z-index: 0; /* 在最底层 */
			}
		}

		.header {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 80px;
			z-index: 2;

			.layout-img {
				width: 1920px;
			}

			.layout-title {
				position: absolute;
				top: 38px;
				left: 50%;
				transform: translate(-50%, -50%);
				font-family: Source Han Sans CN;
				font-size: 32px;
				font-weight: bold;
				text-align: center;
				display: flex;
				align-items: center;
				letter-spacing: 0.1em;
				font-variation-settings: "opsz" auto;
				color: #d8f0ff;
				text-shadow: 0px 0px 4px #0091ff, 0px 0px 30px #0091ff;
			}

			.meun-vehicle {
				position: absolute;
				left: 383.01px;
				top: 19px;
				cursor: pointer;
			}
			.meun-battery {
				position: absolute;
				left: 506.01px;
				top: 19px;
				cursor: pointer;
			}
			.meun-cabinet {
				position: absolute;
				left: 629.01px;
				top: 19px;
				cursor: pointer;
			}
			.meun-fault {
				position: absolute;
				right: 629.01px;
				top: 19px;
				cursor: pointer;
			}
			.meun-data {
				position: absolute;
				right: 506.01px;
				top: 19px;
				cursor: pointer;
			}
			.meun-no {
				position: absolute;
				right: 383.01px;
				top: 19px;
				cursor: pointer;
			}

			.menu-bg {
				position: relative;
				width: 123px;
				height: 32px;
			}

			.meun-title {
				position: absolute;
				top: 14px;
				left: 50%;
				transform: translate(-50%, -50%);
				font-family: Source Han Sans;
				font-size: 16px;
				font-weight: normal;
				text-align: center;
				font-variation-settings: "opsz" auto;
				color: #adc6ff;
				white-space: nowrap;
			}

			.time-container {
				position: absolute;
				left: 32px;
				top: 19px;
				width: 280px;
			}

			.date {
				font-family: PingFang SC;
				font-size: 16px;
				font-weight: 500;
				letter-spacing: 1.05px;
				color: #56acff;
				margin-right: 16px;
			}

			.date-day {
				font-family: ZhanKuHei;
				font-size: 22px;
				margin-top: 2px;
				letter-spacing: 1.2px;
				color: #d8f0ff;
				text-shadow: 0px 0px 4px #0091ff, 0px 0px 10px #0091ff;
			}

			.effect {
				position: absolute;
				right: 82px;
				top: 19px;
				width: 20px;
				height: 20px;
			}

			.logout {
				position: absolute;
				right: 12px;
				top: 22px;
				font-family: PingFang SC;
				font-size: 16px;
				font-weight: 500;
				letter-spacing: 1.05px;
				color: #56acff;
				margin-right: 16px;
				cursor: pointer;
			}
		}
	}
</style>
